<template>

<svg width="100" height="100" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M25.1042 36.3709H75.1251L72.9502 85.18H27.279L25.1042 36.3709Z" stroke="black" stroke-width="4"/>
<rect width="60.2292" height="13.2191" transform="matrix(1 0 0 -1 20 36.3709)" stroke="black" stroke-width="4"/>
<rect x="43.4792" y="14" width="14.2917" height="9.15172" stroke="black" stroke-width="4"/>
<path d="M58.7917 85.18V59.7585M42.4584 85.18V51.1152" stroke="black" stroke-width="4"/>
</svg>

</template>
